// extracted by mini-css-extract-plugin
export var backgroundImage = "BoxedOpeningHero-module--background-image--b02c7";
export var box = "BoxedOpeningHero-module--box--d75a9";
export var content = "BoxedOpeningHero-module--content--28af0";
export var contentBox = "BoxedOpeningHero-module--content-box--2a38a";
export var contentBoxFooter = "BoxedOpeningHero-module--content-box-footer--b11db";
export var header = "BoxedOpeningHero-module--header--11e16";
export var subtitle = "BoxedOpeningHero-module--subtitle--28a36";
export var title = "BoxedOpeningHero-module--title--40f9c";